<template>
  <Head title="Settings - Team Member" />
  
  <AppLayout>
    <div class="container-fluid">
      <div class="row justify-content-center mx-4">
        <div class="col p-0"> 
          <team-member-edit :client="client" :user="user" :user_logged_in="user_logged_in"></team-member-edit>
        </div>
      </div>
    </div>
  </AppLayout>
</template>

<script setup>
import { Head } from '@inertiajs/vue3';
import AppLayout from '../../Layouts/AppLayout.vue';

defineProps({
  client: Object,
  user: Object,
  user_logged_in: Object
});
</script>

